import React, { ReactNode, memo } from 'react';
import Container from '../../Utils/Container/Container';
import QuoteFormHeadingBarLoadingState from '../../QuoteFormHeadingBar/QuoteFormHeadingBarLoadingState';
import Grid from '../../Utils/Grid/Grid';
import Col from '../../Utils/Col/Col';
import { withBlokWrapper } from '../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../interfaces/enums/Theme.enum';

interface QuoteStageMainLayoutLoadingStateProps {
  leftColumn: ReactNode;
  rightColumn: ReactNode;
}

const QuoteStageMainLayoutLoadingState: React.FC<
  QuoteStageMainLayoutLoadingStateProps
> = ({ leftColumn, rightColumn }) => {
  return (
    <div className="xl:pb-20">
      <Container startingBreakpoint="sm">
        <QuoteFormHeadingBarLoadingState isBottomBorderRequired={false} />
        <Grid gapY="gap-y-0">
          <Col
            span={{ xl: 6, xxl: 5 }}
            start={{ xxl: 2 }}
            order={{ default: 2, xl: 1 }}
          >
            {leftColumn}
          </Col>
          <Col
            span={{ xl: 5, xxl: 4 }}
            start={{ xl: 8, xxl: 8 }}
            order={{ default: 1, xl: 2 }}
          >
            {rightColumn}
          </Col>
        </Grid>
      </Container>
    </div>
  );
};

export default memo(
  withBlokWrapper(QuoteStageMainLayoutLoadingState, Theme.LIGHT)
);
